import { operatorValues } from 'components/common/dataGrid/operatorValues';

export const CustomFilterOperator = {
  DATE_RANGE: operatorValues.dateRange,
  DATE_RANGE_PICKER: operatorValues.dateRangePicker,
  CONTAINS: operatorValues.contains,
} as const;

export type CustomFilterOperatorValue =
  (typeof CustomFilterOperator)[keyof typeof CustomFilterOperator];
